import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api';

/**
 * Fires a fire-and-forget /api/analytics/pageview each time the route changes.
 * Errors are swallowed so analytics never breaks the app.
 */
export default function usePageTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    // Don't track admin-internal pages (skews analytics)
    if (pathname.startsWith('/admin')) return;
    api.post('/analytics/pageview', {
      path: pathname,
      referrer: document.referrer || '',
    }).catch(() => {});
  }, [pathname]);
}
